import {environment} from "../../../environments/environment";

export let remoteMpiArray = [
    {
      name: 'IdMerchant',
      value: 718301258,
    },
    {
      name: 'IdSession',
      value: new Date().valueOf(),
    },
    {
      name: 'Amount',
      value: 0,
    },
    {
      name: 'Currency',
      value: 978,
    },
    {
      name: 'CCNumber',
      value: 0,
    },
    {
      name: 'CCExpDate',
      value: 0,
    },
    {
      name: 'CVVCode',
      value: 0,
    },
    {
      name: 'URLRetour',
      value: environment.apiBaseUrl+'/handleremotempi',
    },
    {
      name: 'URLHttpDirect',
      value: environment.apiBaseUrl+'/handleremotempi',
    }
];
